export const SERVER_ERROR_MESSAGE =
  'Unable to connect to the server. Please check your internet connection and try again.'

export const SERVER_TIMEOUT_MESSAGE = 'Server is taking too long to respond. Please try again.'

export const withServerTimeout = async <T,>(request: Promise<T>): Promise<T> => {
  let timeoutId: number | undefined

  const timeout = new Promise<never>((_, reject) => {
    timeoutId = window.setTimeout(() => {
      reject(new Error(SERVER_TIMEOUT_MESSAGE))
    }, 15000)
  })

  try {
    return await Promise.race([request, timeout])
  } finally {
    if (timeoutId !== undefined) {
      window.clearTimeout(timeoutId)
    }
  }
}
